import React from 'react';
import { specialStages } from '../../../../utils';
import stages from '../../../stages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Menu from '@material-ui/core/Menu';
import MenuItem from './StageSelectorItem';

const useStyles = makeStyles((theme: any) => ({
  menu: {
    '& .MuiList-padding': {
      padding: 0,
    },
    '& .MuiPopover-paper': {
      backgroundColor: theme.palette.brand.greyLight,
      border: `1px solid ${theme.palette.brand.greyDark}`,
    },
  },
}));

export default function StageSelector({
  anchorEl,
  open,
  setOpen,
  onChange,
  setAutoSave = (arg) => {},
}) {
  const classes = useStyles();

  const stagesToDisplay = stages.filter(
    (stage) => !specialStages.includes(stage.value),
  );

  function handleChange(stageName: string) {
    onChange(stageName);
    handleClose();
  }

  function handleClose() {
    setOpen(false);
    setAutoSave(true);
  }

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      className={classes.menu}
      keepMounted
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      {stagesToDisplay.map((stage, i) => {
        return (
          <MenuItem
            key={stage.value}
            stage={stage}
            totalStages={stagesToDisplay.length}
            index={i}
            onClick={handleChange}
          />
        );
      })}
    </Menu>
  );
}
